<template>
  <div id="closeModal" class="closeIconModal closeModal" v-on:click="hideModal">
    ×
  </div>

  <div class="modalContents">
    <h3>運営会社</h3>
    <p>
      <br />
      運営会社：株式会社百森
      <br />
    </p>
  </div>
</template>

<script lang="ts">
import { useStore } from "@/store";
import { useModal } from "../shared/useModal";
import { defineComponent, onMounted } from "vue";

export default defineComponent({
  setup(props) {
    const store = useStore();
    const { hideModal } = useModal();
    onMounted(() => {});
    return {
      hideModal: () => hideModal(),
    };
  },
});
</script>
